import { IAddressSearch } from '~interfaces/IStoresInterfaces';
import { IBrowserLocation } from '~repositories/UserLocationRepository';

const expirationTime = 2 * 60 * 60000;
const SS_KEYS = {
    USER_ZIP_CODE: 'user_zip_code',
    USER_LOCATION: 'user_browser_location',
    USER_FULL_ADDRESS: 'user_full_address'
};
const SS_NAMESPACE = 'LOCATION+';

export const LocationCache = {
    getSSUserZipCodeKey() {
        return SS_NAMESPACE + SS_KEYS.USER_ZIP_CODE;
    },

    getSSUserBrowserLocationKey() {
        return SS_NAMESPACE + SS_KEYS.USER_LOCATION;
    },

    getSSUserFullAddressKey() {
        return SS_NAMESPACE + SS_KEYS.USER_FULL_ADDRESS;
    },

    setUserZipCode(zip: string) {
        const data = {
            zip,
            expires: Date.now() + expirationTime
        };
        localStorage.setItem(this.getSSUserZipCodeKey(), JSON.stringify(data));
    },

    setUserFullAddress(fullAddress: IAddressSearch) {
        localStorage.setItem(this.getSSUserFullAddressKey(), JSON.stringify(fullAddress));
    },

    setUserBrowserLocation(location: IBrowserLocation) {
        const data = {
            location,
            expires: Date.now() + expirationTime
        };
        localStorage.setItem(this.getSSUserBrowserLocationKey(), JSON.stringify(data));
    },

    getUserFullAddress() {
        const item = localStorage.getItem(this.getSSUserFullAddressKey());
        if (!item) {
            return undefined;
        }

        return JSON.parse(item);
    },

    getUserBrowserLocation() {
        const item = localStorage.getItem(this.getSSUserBrowserLocationKey());

        if (!item) {
            return undefined;
        }

        const parsedItem = JSON.parse(item);
        const isExpired = parsedItem.expires < Date.now();

        if (isExpired) {
            return undefined;
        }

        return parsedItem.location;
    },

    getUserZipCode() {
        const item = localStorage.getItem(this.getSSUserZipCodeKey());

        if (!item) {
            return undefined;
        }

        const parsedItem = JSON.parse(item);
        const isExpired = parsedItem.expires < Date.now();

        if (isExpired) {
            return undefined;
        }

        return parsedItem.zip;
    }
};
